/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ConnectionUnknownIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACaklEQVR4nN1VPYgTURDeeBaKnD+dqKV/YKWghT+k8E5z7s7PBt7OrAmXxkZsxFoJWAjXiNgpcjYiimilneDPIXiKICpcYaMIgieKeIKioPI2u8nLxjuSXCoHHuy+eW+/mW/mm/W8/8aA9RGSfAeS98jyCkivAOlxAN02EAAkmULWP/9cpC+R5cToaHXFokCKtdqyQ8asDcJoB1F8BFkvIctHB2jWZmWMGRpIVglosbgUWIKEwhQIWB4H5XirN2jDUH1kfdsA0a9E0cG+igysD5BlAsrRHs/zCm0giMNIcjXN5heGUWWxRX6NGI3neC8g6+kkE5KfEGqpKxBjzPIwrGxoUCETQPLOKfATZtmcC+pMA0Tn8r5uAYeAtdrknXQuYDngZgKs17LC24bw+rFSqbISSa6n2fwIWMYyH1FtNZK8QdbfAcfFeT/SaEP5hiQzQHIRMRrJHSkgy/k0ky+IZkvmsLT65XhT70UmuZ+7WMgyAZLper2+pCcq7ChA1O3IehJIPjSA5DOR7MvOGGNWOVqoOmK8haQ3u1a57XdguZFS8gnAbGz5onG7nwkNQz3mqPxoL0kVmiCs97JNSw1RDPbZ9w+vsfMKWCftss+28J0Rkz5LB9tlRF3X3kE6a0ECkv35e0B6zvp836y399IsznYCOMVNBOaAAMmp1HfBvWMHnlVyAh5GO5njXZm63S7rAEgpmWxxnhTedtVMW/Qsd5ygpq3anffbCwJYWloAOJxN0Gb0LGPueSLZHXC8t33PmbZ5HQDL0/YayRSwPnSif+Getx+37ZwL8nlHLbo121Xz/mJb627fAN3aX604ku+IH3RIAAAAAElFTkSuQmCC)
 */
export const ConnectionUnknownIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M2 3a1 1 0 0 1 1-1c6.92 0 12.97 3.7 16.3 9.22.22.37-.15.86-.6.9-.2.02-.4.06-.6.12a.58.58 0 0 1-.67-.22C14.43 7.2 9.1 4 3 4a1 1 0 0 1-1-1ZM15.48 15.15a.5.5 0 0 0 .02-.47A14 14 0 0 0 3 7a1 1 0 0 0 0 2 12 12 0 0 1 10.95 7.09c.18.39.74.44.96.07l.57-1.01ZM2 13a1 1 0 0 1 1-1 9 9 0 0 1 9 9 1 1 0 1 1-2 0 7 7 0 0 0-7-7 1 1 0 0 1-1-1ZM2 17.83c0-.46.37-.83.83-.83C5.13 17 7 18.87 7 21.17c0 .46-.37.83-.83.83H3a1 1 0 0 1-1-1v-3.17Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M18.09 14.63c.4-.7 1.43-.7 1.82 0l3.96 6.9c.38.66-.12 1.47-.91 1.47h-7.92c-.79 0-1.3-.81-.91-1.48l3.96-6.9Zm.46 1.87h.9c.3 0 .52.26.5.55l-.22 2.02c-.01.16-.17.26-.33.23a1.93 1.93 0 0 0-.8 0c-.16.03-.32-.07-.33-.23l-.21-2.02a.5.5 0 0 1 .5-.55ZM19 22a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
